export default __webpack_public_path__ + "static/media/custom_bg.279b0425.jpg";